import { useNavigate } from "react-router-dom";
import {
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import { MdEdit, MdDelete, MdCheckCircle } from "react-icons/md";

import { useImportacionesContext } from "../importaciones-context";

export function ImportacionesTable() {
  const navigate = useNavigate();

  const { importaciones, deleteImportacion, verifyImportacion } =
    useImportacionesContext();

  return (
    <Paper
      sx={{ padding: 1 }}
      className="animate__animated animate__fadeIn"
      variant="outlined"
    >
      <Stack>
        <Stack justifyContent="space-between" direction="row" padding={2}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="h6">Importaciones</Typography>
          </Stack>

          {/* <Button
            variant="contained"
            color="success"
            size="small"
            fullWidth={false}
            onClick={() => navigate("add")}
          >
            Agregar
          </Button> */}
        </Stack>

        {!!importaciones.length ? (
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Importación",
                  // "Estado",
                  // "Opciones"
                ].map((label, i) => (
                  <TableCell key={i}>{label}</TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {importaciones.map((importacion, index) => (
                <TableRow key={importacion.importacion_id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography variant="body2">
                        {importacion.importacion_detalles}
                      </Typography>

                      {!!importacion.importacion_principal && (
                        <Chip
                          label="Principal"
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      )}
                    </Stack>
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={
                        !!importacion.importacion_verificada
                          ? "Verificada"
                          : "Pendiente"
                      }
                      color={
                        !!importacion.importacion_verificada
                          ? "success"
                          : "warning"
                      }
                      variant="outlined"
                      size="small"
                    />
                  </TableCell>

                  <TableCell align="center">
                    {!importacion.importacion_verificada ? (
                      <Stack direction="row" justifyContent="center">
                        <Tooltip title="Verificar">
                          <IconButton
                            color="success"
                            size="small"
                            onClick={async () =>
                              await verifyImportacion({
                                importacionId: importacion.importacion_id,
                              })
                            }
                          >
                            <MdCheckCircle />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Modificar">
                          <IconButton
                            color="warning"
                            size="small"
                            onClick={() =>
                              navigate(`${importacion.importacion_id}/edit`)
                            }
                          >
                            <MdEdit />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            size="small"
                            onClick={async () => {
                              await deleteImportacion({
                                importacionId: importacion.importacion_id,
                              });
                            }}
                          >
                            <MdDelete />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography align="center" variant="overline">
            Sin importaciones
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
